import axios from "axios";

export const getUserData = async mock => {
  if (mock) {
    const response = await axios.get(
      "https://api.fleece.dev/data/api/quick/user"
    );
    return response;
  }
};
